//工具函数
export default {
  getQueryString: function (name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let result = window.location.search.substr(1).match(reg);
    return result ? decodeURIComponent(result[2]) : null;
  },
  setStore: function (name, content) {
    if (!name) return;
    if (typeof content !== 'string') {
      content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
  },
  getStore: function (name) {
    if (!name) return;
    return window.localStorage.getItem(name);
  },
  removeStore: function (name) {
    if (!name) return;
    window.localStorage.removeItem(name);
  },
  banBack: function () {
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL);
    });
  },
  isIosOrAndriod:function(){
    const u = navigator.userAgent;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if(isAndroid){
      return 'android'
    }else if(isiOS){
      return 'ios'
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/utils.js